export default __webpack_public_path__ + "static/media/job_offer14_xl.dc23b195.jpg";